import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { UserAuthService } from '../services/user-auth.sevice';
import { UserPermission } from '../store/state/auth-user';
import { featureName, moduleName, operationName } from '../constant/user-role-constant';

export interface Permission {

    // Report Management Permissions
    reportManagementCreate: "reportManagementCreate";
    reportManagementEdit: "reportManagementEdit";
    reportManagementView: "reportManagementView";
    reportManagementDelete: "reportManagementDelete";
    reportManagementAll: "reportManagementAll";
}

@Directive({
    selector: '[appReportPermission]'
})
export class ReportPermissionDirective {

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private userAuthService: UserAuthService
    ) { }

    @Input('appReportPermission') set appReportHasPermission(permissionKeys: (keyof Permission)[] | keyof Permission) {

        const permissionsArray = Array.isArray(permissionKeys) ? permissionKeys : [permissionKeys];
        const permissionSets: UserPermission[] = [];

        permissionsArray.forEach(permissionKey => {
            const mappedPermissions = this.mapPermission(permissionKey);
            permissionSets.push(...mappedPermissions);
        });

        const hasPermission = this.userAuthService.hasPermission(permissionSets);
        if (hasPermission) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }

    private mapPermission(permissionKey: keyof Permission): UserPermission[] {
        const permissionMappings: Record<keyof Permission, UserPermission> = {
            reportManagementCreate: { moduleName: moduleName.report, featureName: featureName.report, operationName: operationName.create },
            reportManagementEdit: { moduleName: moduleName.report, featureName: featureName.report, operationName: operationName.write },
            reportManagementView: { moduleName: moduleName.report, featureName: featureName.report, operationName: operationName.view },
            reportManagementDelete: { moduleName: moduleName.report, featureName: featureName.report, operationName: operationName.delete },
            reportManagementAll: { moduleName: moduleName.report, featureName: featureName.report, operationName: operationName.all },
        };

        const permission = permissionMappings[permissionKey];
        return permission ? [permission] : [];
    }

}